import { Line } from 'react-chartjs-2';
import * as React from 'react';
import Chartify from  '@shipsy/chartify';

class DualLineViz extends React.PureComponent<any, any> {

  render() {
    const { formData, chartData } = this.props;
    const chartifyInstance = new Chartify.DualLineData(chartData, formData);
    const chartifyData = chartifyInstance.getManipulatedChartDataAndOptions();
    return (
      <Line
        data={chartifyData.data.dualLineChartData}
        options={chartifyData.options} />
    );
  }
}

export default DualLineViz;
